export default function Machines_A_4 (number = 1) {
  return {
    name: '火力发电机',
    icon: '/static/img/machines/a4.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_4.js